import { render, staticRenderFns } from "./ListProjects.vue?vue&type=template&id=7d20a3ce&lang=pug"
import script from "./ListProjects.vue?vue&type=script&lang=js"
export * from "./ListProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d20a3ce')) {
      api.createRecord('7d20a3ce', component.options)
    } else {
      api.reload('7d20a3ce', component.options)
    }
    module.hot.accept("./ListProjects.vue?vue&type=template&id=7d20a3ce&lang=pug", function () {
      api.rerender('7d20a3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/projects/ListProjects.vue"
export default component.exports